import { UseQueryOptions, UseQueryResult, useQuery } from 'react-query';
import { captureException } from '@sentry/react';
import { useServices } from 'services/useServices';
import { QUERY_KEYS } from 'utils/queryKeys';
import { isEmpty } from 'ramda';
import { FilesFilter, GetFilesResponse } from 'services/api/enmonTools';

export const useFiles = (
  filter: FilesFilter | undefined = {},
  options: UseQueryOptions<GetFilesResponse> = {},
): UseQueryResult<GetFilesResponse> => {
  const {
    enmonTools: {
      files: { getFiles },
    },
  } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.enmonTools.files.filter(filter),
    queryFn: async () => await getFiles(filter),
    enabled: !isEmpty(filter),
    onError: error => {
      console.error(error);
      captureException(error);
    },
    ...(options && options),
  });
};
